import { Link } from 'react-router-dom';
import {
  ArrowRight, ShoppingBag, Building2, Store, Monitor,
  Home, Briefcase, Truck, Layers, Ship
} from 'lucide-react';
import { FadeInUp } from '../animations';

const buyerTypes = [
  { icon: <ShoppingBag size={20} />, label: 'Fashion Brands' },
  { icon: <Ship size={20} />, label: 'Importers' },
  { icon: <Store size={20} />, label: 'Wholesalers' },
  { icon: <Building2 size={20} />, label: 'Retailers' },
  { icon: <Monitor size={20} />, label: 'E-commerce Brands' },
  { icon: <Layers size={20} />, label: 'Private Label Businesses' },
  { icon: <Home size={20} />, label: 'Hospitality Companies' },
  { icon: <Briefcase size={20} />, label: 'Interior & Project Buyers' },
  { icon: <Truck size={20} />, label: 'Distributors' },
];

const ForBuyersSection = () => (
  <section className="py-24 lg:py-32 bg-white" data-testid="for-buyers-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
        <FadeInUp>
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-[#0B2A57] mb-6" style={{ fontFamily: 'Cabinet Grotesk' }}>
            YOUR INDIA SOURCING PARTNER.
          </h2>
          <p className="text-base text-[#6B7280] leading-relaxed mb-8">
            Instead of managing multiple manufacturers, suppliers and production conversations yourself, work with one sourcing partner who understands your requirements and coordinates the process in India.
          </p>
          <Link
            to="/request-sourcing"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-[#0B2A57] text-white text-sm font-semibold tracking-wider uppercase transition-all hover:shadow-lg hover:-translate-y-0.5"
            data-testid="buyers-cta"
          >
            Start a Sourcing Request <ArrowRight size={18} />
          </Link>
        </FadeInUp>
        <FadeInUp delay={0.2}>
          <div className="grid grid-cols-3 gap-3">
            {buyerTypes.map((bt) => (
              <div key={bt.label} className="flex flex-col items-center gap-2 p-4 bg-[#fafaf9] border border-[#E5E0D8]/60 text-center">
                <div className="text-[#1E3D66]">{bt.icon}</div>
                <span className="text-xs font-medium text-[#0B2A57]">{bt.label}</span>
              </div>
            ))}
          </div>
        </FadeInUp>
      </div>
    </div>
  </section>
);

export default ForBuyersSection;
